import isEmpty from "assets/scripts/utils/isEmpty";
import { REQUIRED, ERRORS } from "assets/scripts/constants/FormMessages";
const R_STATE = /^[A-Za-z]{2}$/;
export default function getStateError(value, required) {
    if (isEmpty(value)) {
        return required ? REQUIRED : null;
    }
    return R_STATE.test(value) ? null : ERRORS.STATE;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/getStateError.ts